import React from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import i18n from "../../i18nextInitiator";

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");
/**
 * The continue button.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ButtonWithLoading = (props) => {
  const { action, disabled, text, loading, ...restProps } = props;

  return (
    <Grid container justifyContent="center">
      <Button
        onClick={action}
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        size={"large"}
        disabled={disabled || loading}
        style={{ fontSize: "1.5rem" }}
        {...restProps}
      >
        {loading ? <CircularProgress color="secondary" /> : text ?? t("submit")}
      </Button>
    </Grid>
  );
};
export default ButtonWithLoading;
